import UserServices from '@/services/users'

const state = () => ({
  images: []
})

const getters = {
  images: state => state.images,
  image: state => internalNumber => {
    const image = state.images.find(image => image.internalNumber === internalNumber)
    return image ? 'data:image;base64,' + image.data : null
  }
}

const mutations = {
  setImage (state, { internalNumber, image }) {
    state.images.push({
      internalNumber,
      data: image
    })
  },
  removeImages (state) {
    state.images = []
  }
}

const actions = {
  async downloadImage ({ commit, getters }, internalNumber) {
    const image = await UserServices.getImage(internalNumber)
    commit('setImage', { internalNumber, image })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
